import { api } from '../lib/api';
import type { ApiResponse } from '../types';

export interface PublicSettings {
  terms_content?: string;
  privacy_content?: string;
  site_name?: string;
  main_city?: string;
  about_page_content?: string;
  faq_items?: { question: string; answer: string }[];
  how_it_works_companies?: string;
  how_it_works_candidates?: string;
  facebook_url?: string;
  instagram_url?: string;
  contact_email?: string;
  contact_phone?: string;
  support_email?: string;
}

class SettingsService {
  async getPublicSettings(): Promise<PublicSettings> {
    // Tenta rota pública primeiro
    try {
      const resp = await api.get<ApiResponse<PublicSettings> | PublicSettings>('/public/settings');
      if ((resp as any)?.data) return (resp as any).data as PublicSettings;
      return resp as PublicSettings;
    } catch {
      // Fallback para uma possível rota pública sem prefixo
      try {
        const resp = await api.get<ApiResponse<PublicSettings> | PublicSettings>('/settings');
        if ((resp as any)?.data) return (resp as any).data as PublicSettings;
        return resp as PublicSettings;
      } catch {
        // Sem rota pública disponível
        return {};
      }
    }
  }
}

export const settingsService = new SettingsService();
